export const PRIVATE_CUSTOMER_STRING = 'private'
export const BUSINESS_CUSTOMER_STRING = 'business'
